import React, { memo } from 'react'
import EmptyTableContent from '../error/EmptyTableContent'
import TableSkeleton from '../skeleton/tableSkeleton'
import { removeSwal } from '../../functions/removeSwal'

function CustomersCategoryTable({ search, setCustomerTypes, customerTypes }) {
  const removeHandler = (id) => {
    removeSwal('admin/site-options/customer-types/remove', customerTypes, id, setCustomerTypes)
  }

  return (
    <div className="relative rounded-2xl border border-light-gray dark:border-gray-700 overflow-auto scroll-smooth">
      {customerTypes?.length > 0 &&
      customerTypes.filter(({ value }) => value?.toLowerCase().includes(search?.toLowerCase()))
        ?.length > 0 ? (
        <table className="w-full text-sm text-right relative">
          <thead className="text-md bg-light-blue dark:bg-slate-800 sticky top-0 w-full z-10">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                ردیف
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                نام دسته بندی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                رنگ دسته بندی
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                عملیات
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {customerTypes
              .filter(({ value }) => value?.toLowerCase().includes(search?.toLowerCase()))
              .map((customer_type, index) => {
                return !customer_type === customer_type?.id ? (
                  <TableSkeleton key={index} index={index} count={4} />
                ) : (
                  <tr key={index} className="border-b border-b-light-gray dark:border-b-gray-700">
                    <td className="px-6 py-4 dark:text-amber-50">{index + 1}</td>
                    <td className="px-6 py-4 dark:text-amber-50">{customer_type?.value}</td>
                    <td className="px-6 py-8 flex dark:text-amber-50">
                      <div
                        className="w-5 h-5 mx-2 rounded-full"
                        style={{ backgroundColor: `${customer_type?.color}` }}
                      ></div>
                      <div style={{ color: `${customer_type?.color}` }} dir={'ltr'}>
                        {customer_type?.color}
                      </div>
                    </td>
                    <td className="px-3 py-4">
                      <button
                        className="px-6 py-4 text-red-500"
                        onClick={() => removeHandler(customer_type?.id)}
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'دسته بندی ای ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(CustomersCategoryTable)
